<template>
  <div class="homepage">
    <Header></Header>
    <div class="banner">
      <el-carousel :interval="5000" height="800px">
        <el-carousel-item v-for="(i, index) in banners" :key="index">
          <img
            style="cursor: pointer;"
            @click="toDetail(index)"
            :src="i"
            alt=""
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="container">
      <div class="homepage-type flex-row">
        <span
          @click="getList('新闻动态', 'news')"
          :class="current == '新闻动态' ? 'type-active' : ''"
          >新闻动态</span
        >
        <span
          @click="getList('项目预告', 'xmyg')"
          :class="current == '项目预告' ? 'type-active' : ''"
          >项目预告</span
        >
        <span
          @click="getList('产业观察', 'cygc')"
          :class="current == '产业观察' ? 'type-active' : ''"
          >产业观察</span
        >
        <span
          @click="getList('专题策划', 'ztch')"
          :class="current == '专题策划' ? 'type-active' : ''"
          >专题策划</span
        >
      </div>
      <div class="flex-row homepage-news">
        <div
          v-for="(i, index) in list"
          :key="index"
          @click="$router.push({ name: 'NewsDetail', query: { id: i.id } })"
        >
          <img :src="i.thumb && i.thumb[0]" alt="" />
          <div :class="current == '新闻动态' ? 'new-content' : 'new-content2'">
            <p>
              {{ i.articleTitle }}
            </p>
            <p class="date">
              {{ i.publishTime && i.publishTime.slice(0, 10) }}
            </p>
            <img
              class="arrow"
              src="@/assets/images/homePage/arrow.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <p @click="jump('中产资讯', '/news?' + current)" class="more">
        更多动态 >>
      </p>
    </div>
    <div class="homepage-service">
      <div class="white-title">产业生态服务</div>
      <div class="container service-content flex-row">
        <div
          style="width: 580px;"
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".1s"
          data-wow-offset="10"
        >
          <img src="@/assets/images/homePage/service.png" alt="" />
          <div>产业投资</div>
          <p>产业投资实操经验丰富,</p>
          <p>20余家成功上市案例</p>
        </div>
        <div
          style="width: 580px;"
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".2s"
          data-wow-offset="10"
        >
          <img src="@/assets/images/homePage/invest.png" alt="" />
          <div>产业精准招商</div>
          <p>数智化招商，“一对一”服务,</p>
          <p>精准招商赋能产业发展</p>
        </div>
        <div
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".1s"
          data-wow-offset="10"
        >
          <img src="@/assets/images/homePage/plan.png" alt="" />
          <div>产业赋能服务</div>
          <p>18万+企业一把手</p>
          <p>国内最大的产业生态圈星友会</p>
        </div>
        <div
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".2s"
          data-wow-offset="10"
        >
          <img src="@/assets/images/homePage/analysis.png" alt="" />
          <div>产业数据分析</div>
          <p>大数据科技全面赋能政企对接,</p>
          <p>数智化助力园区发展</p>
        </div>
        <div
          class="service-item flex-col wow animate__animated animate__fadeInUp"
          data-wow-delay=".3s"
          data-wow-offset="10"
        >
          <img src="@/assets/images/homePage/train.png" alt="" />
          <div>产业人才培训</div>
          <p>产业商学院培养新型</p>
          <p>产业运营和企业管理人才</p>
        </div>
        <!-- <div class="service-item flex-col wow animate__animated animate__fadeInUp" data-wow-delay=".3s" data-wow-offset="10">
          <img src="@/assets/images/homePage/layout.png" alt="" />
          <div>产业项目布局</div>
          <p>专业服务企业,</p>
          <p>直通项目落地最后一公里</p>
        </div> -->
      </div>
    </div>
    <div class="homepage-project">
      <div class="blue-title">落地项目案例</div>
      <div class="container" style="position:relative;width: 1300px;">
        <div class="homepage-map" id="map"></div>
        <div class="exhibit flex-col wow animate__animated animate__fadeInUp">
          <div
            class="exhibit-item"
            v-for="(i, index) in projectList"
            :key="index"
          >
            <span>{{ i.provinceText }}{{ i.cityText }} | </span>
            <span>{{ i.project }}</span>
          </div>
          <p>......</p>
        </div>
      </div>
    </div>
    <!-- <div class="homepage-cooperation">
      <div class="blue-title">合作政府及园区</div>
      <div class="container flex-row homepage-cooperation-list">
        <div v-for="(i, index) in cooperationList" :key="index" class="homepage-cooperation-item flex-row">
          <img :src="i" alt="" />
        </div>
      </div>
      <p class="more" @click="jump('关于我们', '/aboutus','#cooperation')">查看更多 >></p>
    </div> -->
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/css/homepage.css";
import Header from "./Header";
import Footer from "./Footer";
export default {
  name: "HomePage",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      banners: [
        require("@/assets/images/homePage/banner1.jpg"),
        require("@/assets/images/homePage/banner2.jpg"),
        require("@/assets/images/homePage/banner3.jpg"),
        require("@/assets/images/homePage/banner4.jpg"),
        require("@/assets/images/homePage/banner5.jpg")
      ],
      current: "新闻动态",
      type: "news",
      list: [],
      cooperationList: [
        require("@/assets/images/aboutUs/cooperation01.png"),
        require("@/assets/images/aboutUs/cooperation02.png"),
        require("@/assets/images/aboutUs/cooperation03.png"),
        require("@/assets/images/aboutUs/cooperation04.png"),
        require("@/assets/images/aboutUs/cooperation05.png"),
        require("@/assets/images/aboutUs/cooperation06.png"),
        require("@/assets/images/aboutUs/cooperation07.png"),
        require("@/assets/images/aboutUs/cooperation08.png"),
        require("@/assets/images/aboutUs/cooperation09.png"),
        require("@/assets/images/aboutUs/cooperation10.png"),
        require("@/assets/images/aboutUs/cooperation11.png"),
        require("@/assets/images/aboutUs/cooperation12.png"),
        require("@/assets/images/aboutUs/cooperation13.png"),
        require("@/assets/images/aboutUs/cooperation14.png"),
        require("@/assets/images/aboutUs/cooperation15.png")
      ],
      projectList: [],
      provinceJson: {
        上海: [121.490317, 32.122771],
        天津: [117.595907, 39.718327],
        吉林: [125.3245, 44.799841],
        山东: [118.000923, 37.175807],
        山西: [111.949248, 37.857014],
        江苏: [119.767413, 34.041544],
        四川: [104.080989, 31.657689],
        贵州: [106.713478, 27.578343],
        广东: [113.280637, 24.825178],
        广西: [108.320004, 23.82402],
        福建: [118.306239, 27.075302],
        浙江: [120.153576, 30.287459],
        安徽: [117.283042, 32.16119],
        江西: [115.692151, 28.676493],
        河南: [113.765412, 34.757975],
        湖北: [113.398572, 31.684355],
        湖南: [111.882279, 28.99409],
        陕西: [108.948024, 35.263161],
        青海: [96.778916, 36.623178],
        重庆: [107.380246, 30.607807],
        河北: [114.502461, 38.045474],
        内蒙古: [111.670801, 40.818311],
        辽宁: [123.429096, 41.796767],
        黑龙江: [126.642464, 45.756967],
        海南: [110.33119, 20.031971],
        云南: [102.712251, 25.040609],
        西藏: [91.132212, 29.660361],
        新疆: [87.617733, 43.792818],
        北京: [116.418757, 39.917544],
        甘肃: [103.823557, 36.058039],
        宁夏: [106.278179, 38.46637],
        香港: [114.1543731, 22.28198083],
        澳门: [113.5528956, 22.20787],
        台湾: [121.509062, 25.044332]
      },
      provincePoint: []
    };
  },
  methods: {
    getBanner() {
      //轮播图
      this.Axios.post(`/api/index/cms/banner/list`, {}).then(res => {
        // this.banners=res.data.data
      });
    },
    toDetail(index) {
      switch (index) {
        case 0:
          this.$router.push({ path: "/capital" });
          break;
        case 1:
          this.$router.push({ path: "/invest" });
          break;
        case 2:
          this.$router.push({ path: "/train" });
          break;
        case 3:
          this.$router.push({ path: "/plan" });
          break;
        case 4:
          this.$router.push({ path: "/aboutUs" });
          break;
        default:
          break;
      }
    },
    getList(name, type) {
      //推荐文章
      this.current = name;
      sessionStorage.setItem("headCurrent", name);
      this.type = type;
      this.Axios.post(`/api/index/cms/article/recommend?currPage=1&size=3`, {
        category: this.type
      }).then(res => {
        this.list = res.data.data;
      });
    },
    initEchart() {
      var myChart = this.$echarts.init(document.getElementById("map"));
      this.Axios.get(`./static/china.json`).then(res => {
        this.$echarts.registerMap("china", res.data);
        var option = {
          geo: {
            layoutCenter: ["50%", "70%"],
            layoutSize: "100%",
            map: "china",
            silent: true,
            roam: false, //不开启缩放和平移
            zoom: 1.2, //视角缩放比例
            label: {
              normal: {
                show: true,
                fontSize: "14",
                color: "#3f4041"
              },
              emphasis: {
                color: "#3f4041"
              }
            },
            itemStyle: {
              normal: {
                borderColor: "#FFF",
                borderWidth: 2,
                areaColor: "#e5f0f8"
              },
              emphasis: {
                areaColor: "#e5f0f8", //鼠标选择区域颜色
                show: false
              }
            }
          },
          // 鼠标悬浮提示框
          series: [
            {
              name: "城市",
              type: "scatter",
              coordinateSystem: "geo",
              data: this.provincePoint,
              symbol: function(params, v) {
                if (v.data.flag) {
                  return (
                    "image://" +
                    require("../assets/images/homePage/active-point.png")
                  );
                } else {
                  return (
                    "image://" +
                    require("../assets/images/contactUs/address-tip.png")
                  );
                }
              }, // svg图标
              symbolSize: [20, 25],
              hoverAnimation: true,
              silent: false,
              animation: false
            }
          ]
        };
        this.provincePoint.find(v => v.name === "辽宁").flag = true;
        this.getProject();
        myChart.setOption(option);
        myChart.getDom().style.width = "100%";
        myChart.getDom().style.height = "890px";
        myChart.resize();
        myChart.on("click", params => {
          this.provincePoint.forEach(v => (v.flag = false));
          let goal = this.provincePoint.find(v => v.name === params.data.name);
          goal.flag = true;
          myChart.setOption(option, true);
          this.getProject(params.data.code);
        });
      });
    },
    jump(name, path, aName) {
      //aName锚点
      sessionStorage.setItem("headCurrent", name);
      this.$router.push({ path: path });
      document.documentElement.scrollTop = 0;
      setTimeout(() => {
        document
          .getElementById(aName.replace(/#/, ""))
          .scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    },
    getProvincePoint() {
      //获取案例省市
      this.Axios.post(`/api/index/cms/project/list/map`).then(res => {
        res.data.data.map(i => {
          this.provincePoint.push({
            name: i.provinceText,
            value: this.provinceJson[i.provinceText],
            flag: false,
            code: i.province
          });
        });
        this.$nextTick(() => {
          this.initEchart();
        });
      });
    },
    getProject(code = "210000") {
      this.Axios.post(`/api/index/cms/project/list`, { province: code }).then(
        res => {
          this.projectList = res.data.data;
        }
      );
    }
  },

  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 200,
      mobile: false,
      live: false
    });
    wow.init();
    this.getBanner();
    this.getList("新闻动态", "news");
    this.getProvincePoint();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/HomePage.vue